module.exports = __webpack_public_path__ + "assets/img/1.c9657f2d.png";